import { type Api, createApi, createFetchHttpClient, type FetchHttpClientOptions } from '@nutralab/api';

/** The package API over the browser transport, against `NEXT_PUBLIC_API_BASE_URL`. */
export function createBrowserApi(options: Omit<FetchHttpClientOptions, 'baseUrl'> = {}): Api {
    return createApi(createFetchHttpClient({ baseUrl: `${process.env.NEXT_PUBLIC_API_BASE_URL}/api`, ...options }));
}
